import React, { useState } from "react";
import Select from "../common/Select";
import ReportsExpand from "../common/ReportsExpand";

function MonthlyReport({ divisions, isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState("");
  const options = [
    {
      name: "SAFY of Alabama",
      _id: "SAFY of Alabama",
    },
    {
      name: "SAFY of Colorado",
      _id: "SAFY of Colorado",
    },
    {
      name: "SAFY of Indiana",
      _id: "SAFY of Indiana",
    },
    {
      name: "SAFY of Kentucky",
      _id: "SAFY of Kentucky",
    },
    {
      name: "SAFY of Nevada",
      _id: "SAFY of Nevada",
    },
    {
      name: "SAFY of Ohio",
      _id: "SAFY of Ohio",
    },
    {
      name: "SAFY of South Carolina",
      _id: "SAFY of South Carolina",
    },
  ];
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  const openReport = () => {
    const state =
      safyInfo.user.safyInfo.BusinessUnitIdName.toLowerCase() !== "ccplive"
        ? safyInfo.user.safyInfo.BusinessUnitIdName
        : reportData.selectedState;
    const url = `https://safyreports.azurewebsites.net/Reports/MonthlyReport/Default?db=${reportOrg}&c=${state}`;
    window.open(url, "Monthly Report");
  };

  return (
    <ReportsExpand
      title="Monthly Report (old)"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      {safyInfo.user.safyInfo.BusinessUnitIdName.toLowerCase() === "ccplive" ? (
        <div className="row g-3" style={{ minHeight: "60px" }}>
          <div className="col-md-8 col-lg-6">
            <Select
              name="selectedState"
              label="Select State"
              options={options}
              onChange={handleChange}
              value={reportData.selectedState}
            />
          </div>
          <div className="col-md-4 col-lg-6 d-flex align-items-end justify-content-end mb-2">
            {(safyInfo.user.safyInfo.BusinessUnitIdName.toLowerCase() !==
              "ccplive" ||
              reportData.selectedState !== "") && (
              <i
                className="fas fa-arrow-circle-right fa-3x cursor-pointer"
                onClick={openReport}
              ></i>
            )}
          </div>
        </div>
      ) : (
        <div className="row g-3" style={{ minHeight: "60px" }}>
          <div className="col-12 d-flex justify-content-end mb-2">
            <i
              className="fas fa-arrow-circle-right fa-3x cursor-pointer"
              onClick={openReport}
            ></i>
          </div>
        </div>
      )}
    </ReportsExpand>
  );
}

export default MonthlyReport;
